import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Divider,
  Chip,
} from "@mui/material";
import { StyledCard } from "../common/StyledComponents";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import InventoryIcon from "@mui/icons-material/Inventory";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const ProductCard = ({ product, onEdit, onDelete }) => {
  return (
    <StyledCard>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Stack direction="row" spacing={1.5} alignItems="flex-start">
          <InventoryIcon color="primary" sx={{ mt: 0.5 }} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="h6" fontWeight="bold" noWrap>
              {product.name}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block" }}
            >
              ID: {product.id.substring(0, 8)}
            </Typography>
          </Box>
        </Stack>

        <Box sx={{ mt: 1 }}>
          <Chip
            label={`Code: ${product.eTimsItemCode || "PENDING"}`}
            size="small"
            color="secondary"
            variant="outlined"
            sx={{ fontWeight: "bold" }}
          />
        </Box>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={1.2} sx={{ flexGrow: 1 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {product.description || "No description provided."}
          </Typography>

          <Stack direction="row" spacing={1} alignItems="center">
            <ReceiptLongIcon fontSize="small" color="action" />
            <Typography variant="caption" noWrap>
              <b>Narration:</b> {product.eTimsNarration || "N/A"}
            </Typography>
          </Stack>
        </Stack>

        <Stack direction="row" justifyContent="flex-end" spacing={0.5} mt={2}>
          <Tooltip title="Edit Product">
            <IconButton size="small" onClick={onEdit} color="secondary">
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton size="small" onClick={onDelete} color="error">
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Box>
    </StyledCard>
  );
};

export default ProductCard;
